<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
      <div
        class="sm:flex max-w-2xl"
      >
        <img
          class="sm:w-2/6 w-64"
          src="@/assets/password.svg"
        >
      </div>
      <div
        class="text-3xl font-bold mt-8 text-center"
      >
        {{ !isLoggedIn ? 'Ingresa tu ' : 'Configura una ' }}<span class="text-purple-500">contraseña</span> {{ !isLoggedIn ? '' : 'para tu cuenta' }}
      </div>
      <div class="max-w-lg mx-auto p-4">
        <div class="font-bold text-center text-purple-500 font-bold mx-auto text-4xl">
          {{ phoneNumber || tempPhone }}
        </div>
        <div
          v-if="!isLoggedIn"
          class="flex justify-center items-center mx-auto"
        >
          <eva-icon
            width="30"
            height="30"
            name="sync-outline"
            fill="#FF7570"
          />
          <a
            class="max-w-sm text-red-500 text-center font-bold my-0 text-xl mt-1 ml-2"
            @click="goBack()"
          >
            Cambiar número
          </a>
        </div>
      </div>
      <div class="max-w-lg mx-auto bg-bluegray-100 p-4 rounded-md">
        <span class="italic">(Mínimo 6 caracteres).</span>
        <ValidationObserver
          ref="form"
          v-slot="{ invalid, handleSubmit, validate }"
        >
          <form
            id="passForm"
            @submit.prevent="handleSubmit(confirm)"
          >
            <div class="mt-5 text-2xl shadow-md relative">
              <ValidationProvider
                v-slot="{ errors }"
                mode="lazy"
                vid="password"
                name="contraseña"
                rules="required|min:6"
              >
                <input
                  ref="pass"
                  v-model="password"
                  class="w-full p-4 border-2 border-purple-500 border-opacity-0 focus:border-opacity-100 rounded-md"
                  name="password"
                  :type="isPassVisible? 'text' : 'password'"
                  placeholder="Contraseña"
                  @keyup="$event.target.value.length >= 6 && validate()"
                >
                <p
                  v-if="errors.length"
                  class="text-red-400 bg-white text-lg text-center rounded-md -mt-2 pt-4"
                >
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
              <a
                class="mt-2 absolute right-0 top-0 mt-6 mx-4"
                @click="isPassVisible = !isPassVisible"
              >
                <eva-icon
                  width="30"
                  height="30"
                  :name="isPassVisible ? 'eye-off-2-outline' : 'eye-outline'"
                  fill="#6C63FF"
                />
              </a>
            </div>
            <div class="my-1">
              <a
                v-if="!isLoggedIn"
                class="cursor-pointer text-purple-500 text-center w-64 text-xl my-2 mx-auto h-16 leading-14"
                @click="setRecoveryMode"
              >
                Olvidé mi contraseña
              </a>
              <button
                type="submit"
                :disabled="invalid"
                class="disabled:opacity-25 disabled:pointer-events-none block cursor-pointer bg-purple-500 text-white w-64 text-2xl px-2 py-1 rounded-md my-4 mx-auto h-16 leading-14"
              >
                <div
                  class="text-center w-full"
                >
                  Confirmar
                </div>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </f7-page>
</template>
<script>
import * as axios from 'axios'
import { mapState } from 'vuex'
import { firebaseTools, firebaseAuth, emailProvider } from '../utils/firebase'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'Template',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      password: '',
      isPassVisible: false,
    }
  },
  computed: {
    isLoggedIn () {
      return !!this.uid
    },
    getEmail () {
      return `${this.phoneNumber}@cuidarte.co`
    },
    ...mapState({
      uid: state => state.auth.uid,
      hasEmailProvider: state => state.auth.hasEmailProvider,
      phoneNumber: state => state.auth.phoneNumber,
      account: state => state.auth.account,
      isRecovering: state => state.auth.isRecovering,
      tempPhone: state => state.auth.tempPhone,
    }),
  },
  watch: {
  },
  async mounted () {
    // this.$refs.pass.focus()
    if (!this.isLoggedIn && !this.tempPhone) {
      this.$f7router.navigate('/login/', { reloadAll: true })
    }
  },
  methods: {
    async signIn () {
      try {
        await firebaseAuth.signInWithEmailAndPassword(`${this.tempPhone || this.phoneNumber}@cuidarte.co`, this.password)
        await axios({
          url: '/users/deleteShouldSetPass',
          method: 'POST',
          data: {
            uid: this.uid,
          },
        })
        this.$f7.dialog.preloader('Recargando app...')
        location.reload()
      } catch (err) {
        switch (err.code) {
          case 'auth/wrong-password':
            this.$f7.dialog.alert('Contraseña equivocada, por favor reintentalo.', '¡Ups!')
            break
          case 'auth/user-not-found':
            this.$f7.dialog.alert('No encontramos este número de telefono.', '¡Ups!')
            break
        }
        console.error(err)
      }
    },
    goBack () {
      this.$f7.dialog.confirm(`¿Estás seguro de que deseas cambiar el número <span class="font-bold text-purple-500">${this.tempPhone}</span>?`, '¿Seguro?', () => {
        this.$f7router.back('/login/')
      })
    },
    setRecoveryMode () {
      this.$f7.dialog.confirm('Para cambiar tu contraseña, vamos a validar tu linea telefónica con un SMS.', '¿Seguro?', () => {
        this.$store.commit('auth/setIsRecovering', true)
        this.$f7router.back('/login/')
      })
    },
    async onSubmit () {
      this.openModal = true
      const fData = new FormData(document.getElementById('passForm'))
      console.info(fData)
    },
    async confirm () {
      if (this.isLoggedIn) {
        // set Pass
        if (this.hasEmailProvider) {
          // recover
          try {
            this.$f7.dialog.preloader('Actualizando contraseña...')
            await axios({
              url: '/users/updatePassword',
              method: 'POST',
              data: {
                uid: this.uid,
                password: this.password,
              },
            })
            this.$f7.dialog.close()
            this.signIn()
          } catch (err) {
            this.$f7.dialog.close()
            console.error(err)
          }
        } else {
          // sync accounts
          try {
            this.$f7.dialog.preloader('Vinculando cuenta...')
            const credential = emailProvider.credential(this.getEmail, this.password)
            console.info(credential)
            const user = firebaseAuth.currentUser
            const finalCredential = await user.linkWithCredential(credential)
            console.info(finalCredential.user.providerData) // TODO: hide
            await axios({
              url: '/users/deleteShouldSetPass',
              method: 'POST',
              data: {
                uid: this.uid,
              },
            })
            this.$f7.dialog.close()
            this.$f7.views.main.router.navigate('/', { reloadAll: true })
          } catch (err) {
            console.error(err)
            this.$f7.dialog.close()
            switch (err.code) {
              case 'auth/requires-recent-login':
                await firebaseTools.signOut()
            }
          }
        }
      } else {
        this.signIn()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
